export class IdDetalleServicioIdEstadoDto {
  id_DetalleServicioPropiedad!: number
  id_EstadoDetalleServicioPropiedad!:number
}
